import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import type { CommunityMemberMinimal } from "@/entities/IProfile";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
export default function CommonProfileSearchItem(t0) {
  const $ = _c(34);
  const {
    profile,
    onProfileSelect,
    isSelected: t1,
    isHighlighted: t2,
    id
  } = t0;
  const isSelected = t1 === undefined ? false : t1;
  const isHighlighted = t2 === undefined ? false : t2;
  const title = profile.display ?? profile.handle ?? profile.wallet;
  const avatarLabel = title;
  const avatarAltText = `${avatarLabel} avatar`;
  let t3;
  if ($[0] !== profile.display || $[1] !== profile.handle || $[2] !== profile.wallet || $[3] !== title) {
    t3 = [profile.handle, profile.wallet, profile.display].find(value => value !== null && value.length > 0 && value !== title) ?? null;
    $[0] = profile.display;
    $[1] = profile.handle;
    $[2] = profile.wallet;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const secondaryText = t3;
  let t4;
  if ($[5] !== onProfileSelect || $[6] !== profile) {
    t4 = () => onProfileSelect(profile);
    $[5] = onProfileSelect;
    $[6] = profile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onProfileClick = t4;
  const t5 = `tw-relative tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-justify-between tw-rounded-lg tw-border-none tw-bg-transparent tw-px-2 tw-py-2 tw-text-left tw-text-white tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-700 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 ${isHighlighted ? "tw-bg-iron-700" : "tw-bg-transparent"}`;
  let t6;
  if ($[8] !== avatarAltText || $[9] !== profile.pfp) {
    t6 = profile.pfp && <div className="tw-h-6 tw-w-6 tw-overflow-hidden tw-rounded-md tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-white/10"><div className="tw-h-full tw-w-full tw-max-w-full"><div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-text-center"><img src={getScaledImageUri(profile.pfp, ImageScale.W_AUTO_H_50)} alt={avatarAltText} className="tw-mx-auto tw-h-auto tw-max-h-full tw-w-auto tw-max-w-full tw-bg-transparent tw-object-contain" /></div></div></div>;
    $[8] = avatarAltText;
    $[9] = profile.pfp;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== title) {
    t7 = <p className="tw-mb-0 tw-truncate tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-white">{title}</p>;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== secondaryText) {
    t8 = secondaryText && <p className="tw-mb-0 tw-truncate tw-whitespace-nowrap tw-text-xs tw-font-medium tw-text-iron-400">{secondaryText}</p>;
    $[13] = secondaryText;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="tw-w-[12rem] tw-truncate">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-space-x-2">{t6}{t9}</div>;
    $[18] = t6;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== isSelected) {
    t11 = isSelected && <FontAwesomeIcon icon={faCheck} className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" aria-hidden="true" focusable={false} />;
    $[21] = isSelected;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <div className="tw-flex tw-w-full tw-items-center tw-justify-between">{t10}{t11}</div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== onProfileClick || $[27] !== t12 || $[28] !== t5) {
    t13 = <button type="button" onClick={onProfileClick} tabIndex={-1} className={t5}>{t12}</button>;
    $[26] = onProfileClick;
    $[27] = t12;
    $[28] = t5;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== id || $[31] !== isSelected || $[32] !== t13) {
    t14 = <li id={id} role="option" aria-selected={isSelected} className="tw-list-none">{t13}</li>;
    $[30] = id;
    $[31] = isSelected;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
}